<template>
    <div>
    <textarea class="form-control" v-model="handler" @input="change" rows="6"></textarea>
    <div class="helper-text">
        <slot />
    </div>
    </div>


</template>
<style scoped>
.helper-text { font-size:.9em}

</style>
<script>



export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      var text = this.value;
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
